import styled from 'styled-components';

export const SelectAllIcon = styled.img`
    margin-right: 4px;
    cursor: pointer;
`;
